import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { IDropdownOption } from '../../../../shared/components/mat-dropdown/mat-dropdown.component';
import { EWorkflow } from '../../../items/items.interface';

export const DEFAULT_WORKFLOW_NAME = '{{__default__}}';

export interface IWorkflowTransition {
  id?: number;
  nextWorkflowStepId: number;
  workflowStepId: number;
}

export interface IWorkflow {
  id: number;
  name: string;
  startWorkflowStepId: number | null;
  workflowStepAssignments: IWorkflowTransition[];
}

export interface IWorkflowStepOption {
  id: number;
  isDefault: boolean;
  name: string;
  statusCategory: EWorkflow;
}

export type TTransitionFormGroup = FormGroup<{
  nextWorkflowStepId: FormControl<IDropdownOption[] | null>;
  workflowStepId: FormControl<IDropdownOption[] | null>;
}>;

export type TFormControlWorkflow = {
  name: FormControl<string | null>;
  startWorkflowStepId: FormControl<IDropdownOption[] | null>;
  transitions: FormArray<TTransitionFormGroup>;
};

export interface ISaveTransition {
  nextWorkflowStepId: number;
  workflowStepId: number;
}

export interface ISaveWorkflow {
  name: string;
  startWorkflowStepId: number;
  transitions: ISaveTransition[];
}

export interface IEditWorkflow {
  dto: Partial<ISaveWorkflow>;
  id: number;
}

export enum EWorkflowChainSeverity {
  error = 'error',
  warning = 'warning',
}

export enum EWorkflowChainState {
  empty = 'empty',
  error = 'error',
  valid = 'valid',
  warning = 'warning',
}

export interface IWorkflowChainIssue {
  messageKey: string;
  params?: { count?: number; statuses?: string };
  severity: EWorkflowChainSeverity;
}
